import { create } from "zustand";

type ModalVariant = "auth" | "onboarding";

type ModalStore = {
  isOpen: boolean;
  variant: ModalVariant;
  onOpen: (variant?: ModalVariant) => void;
  onClose: () => void;
};

const useAuthModal = create<ModalStore>((set) => ({
  isOpen: false,
  variant: "auth",
  onOpen: (variant = "auth") => set({ isOpen: true, variant }),
  onClose: () => set({ isOpen: false, variant: "auth" }),
}));

export default useAuthModal;
